import React, { Component } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  InputGroup,
  InputGroupText,
  Input,
  Row,
  Col,
  Alert,
} from "reactstrap";

import ReactTooltip from "react-tooltip";

import { FetchData, UploadFile } from "./utils/DataFetch";
import { GetCookie, Timeout } from "./utils/Common";

import {} from "@mui/material";

const moment = require("moment");

export class WorkOrderFollowUpForm extends Component {
  static displayName = WorkOrderFollowUpForm.name;
  constructor(props) {
    super(props);
    this.state = {
      workOrders: [],

      model: { ...this.props.model },
      alert: this.props.alert,
      sortModel: {
        SortBy: "jobDateTime",
        SortDirection: "desc",
      },
    };
    //
    this.user = JSON.parse(GetCookie("user"));

    this.onSave = this.onSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleJobTimeFieldChange = this.handleJobTimeFieldChange.bind(this);
    this.handleSaveEventSuccess = this.handleSaveEventSuccess.bind(this);
    this.keydownHandler = this.keydownHandler.bind(this);
  }

  componentDidMount() {
    let model = { ...this.state.model };
    model.JobDateTime = null;
    model.JobTime = "";
    this.resetFollowUpFlags(model);
    this.setState({ model });

    document.addEventListener("keydown", this.keydownHandler);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.keydownHandler);
  }

  componentDidUpdate() {
    ReactTooltip.rebuild();
  }

  keydownHandler(e) {
    if (e.keyCode === 83 && e.altKey) {
      // Alt+S
      this.onSave();
    }
  }

  handleSaveEventSuccess(alert) {
    const normalizedMessage = this.formatAlertMessage(alert.message);

    this.setState(
      {
        alert: {
          color: alert.color,
          message: normalizedMessage,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState({ alert: { isOpen: false } });
        }, Timeout(normalizedMessage));
      },
    );
  }

  formatAlertMessage(message) {
    if (message === null || message === undefined) return "";
    if (
      typeof message === "string" ||
      typeof message === "number" ||
      typeof message === "boolean"
    ) {
      return String(message);
    }

    if (Array.isArray(message)) {
      return message
        .map((item) => this.formatAlertMessage(item))
        .filter(Boolean)
        .join("; ");
    }

    if (typeof message === "object") {
      const title =
        message.title ||
        message.message ||
        message.Message ||
        message.error ||
        message.type ||
        "";

      let detailText = "";
      if (message.errors && typeof message.errors === "object") {
        detailText = Object.entries(message.errors)
          .map(([field, fieldErrors]) => {
            const messages = Array.isArray(fieldErrors)
              ? fieldErrors
              : [fieldErrors];
            const text = messages.filter(Boolean).join(", ");
            return text ? `${field}: ${text}` : "";
          })
          .filter(Boolean)
          .join("; ");
      }

      const combined = [title, detailText].filter(Boolean).join(": ");
      if (combined) return combined;

      try {
        return JSON.stringify(message);
      } catch (err) {
        return "Unexpected error.";
      }
    }

    return String(message);
  }

  handleChange(e) {
    let model = { ...this.state.model };

    if (e.target.type === "checkbox") model[e.target.name] = e.target.checked;
    else if (e.target.type === "number") {
      if (e.target.value !== "")
        model[e.target.name] = parseInt(e.target.value);
      else model[e.target.name] = null;
    } else if (e.target.name === "CallerType")
      model[e.target.name] = parseInt(e.target.value);
    else {
      if (e.target.name === "RemType") {
        //var index = e.nativeEvent.target.selectedIndex;
        /*if (e.nativeEvent.target[index].text === "N/A") {*/
        if (e.target.value === "d2f8a295-20e1-4653-b7c0-e456057cbd90") {
          // N/A
          model["RemHost"] = "64ecfbe8-9cb7-4af8-8a41-f756aaeaca39"; // N/A
          model["RemClaimFlg"] = true;
          model["RemIntFlg"] = true;
          model["RemProvFlg"] = true;
          model[e.target.name] = e.target.value;
        } else model[e.target.name] = e.target.value;
      } else {
        model[e.target.name] = e.target.value;
      }
    }

    this.setState({ model });
  }

  handleJobTimeFieldChange(e) {
    var jobtime = e.target.value;

    var concatChar = e.target.value;
    var hour = "";
    var minutes = "";
    var amPm = "";

    if (jobtime.length === 4) {
      for (var i = 0, len = jobtime.length; i < len; i++) {
        if (i <= 1) hour += jobtime[i];
        else minutes += jobtime[i];
      }

      if (parseInt(hour) < 12)
        concatChar = parseInt(hour) + ":" + minutes + " AM";
      else if (parseInt(hour) === 12)
        concatChar = parseInt(hour) + ":" + minutes + " PM";
      else {
        concatChar = parseInt(hour) - 12 + ":" + minutes + " PM";
      }
    } else if (jobtime.length === 8) {
      for (var i1 = 0, len1 = jobtime.length; i1 < len1; i1++) {
        if (i1 <= 1) hour += jobtime[i1];
        else if (i1 === 3 || i1 === 4) minutes += jobtime[i1];
        else if (i1 === 6 || i1 === 7) amPm += jobtime[i1];
      }

      if (parseInt(hour) < 12)
        concatChar = parseInt(hour) + ":" + minutes + " " + amPm;
      else if (parseInt(hour) === 12)
        concatChar = parseInt(hour) + ":" + minutes + " " + amPm;
      else {
        concatChar = parseInt(hour) - 12 + ":" + minutes + " PM";
      }
    }

    let model = { ...this.state.model };
    model[e.target.name] = concatChar;
    this.setState({ model });
  }

  resetFollowUpFlags(model) {
    model.FailedFlg = false;
    model.InvoicedFlg = false;
    model.IsDeletedFlg = false;
    model.TransportationFlg = false;
    model.TransConfFlg = false;
    model.IntConfFlg = false;
    model.IntFinalConfEmailSentFlg = false;
    model.ProvConfFlg = false;
    model.ClmConfFlg = false;
    model.BillReviewedFlg = false;
    model.AuditFlg = false;
    model.PurpleReportFlg = false;
    model.RepAuthorizedFlg = false;
    model.SelectedFlg = false;
    model.RemIntFlg = false;
    model.RemClaimFlg = false;
    model.RemProvFlg = false;
    model.RemFinalFlg = false;
  }

  formatFollowUpHistoryDescription(jobNum, jobDate, jobTime) {
    const safeJobNum = jobNum === null || jobNum === undefined ? "" : jobNum;
    let dateText = "";
    let timeText = "";

    if (jobDate) {
      const dateMoment = moment(
        jobDate,
        ["YYYY-MM-DD", "MM/DD/YYYY", moment.ISO_8601],
        true,
      );
      dateText = dateMoment.isValid()
        ? dateMoment.format("MM/DD/YYYY")
        : jobDate;
    }

    if (jobTime) {
      const timeMoment = moment(
        jobTime,
        ["h:mm A", "hh:mm A", "HHmm", "HH:mm", "hmm A"],
        true,
      );
      timeText = timeMoment.isValid() ? timeMoment.format("h:mm A") : jobTime;
    }

    if (dateText && timeText) {
      return `[${safeJobNum}], [${dateText}] at [${timeText}]`;
    }

    if (dateText) {
      return `[${safeJobNum}], [${dateText}]`;
    }

    if (timeText) {
      return `[${safeJobNum}] at [${timeText}]`;
    }

    return `[${safeJobNum}]`;
  }

  async saveFollowUpHistory(
    originJobId,
    followupJobNum,
    followupJobDateTime,
    followupJobTime,
    formFile,
  ) {
    if (!originJobId) {
      return "Original job id is missing; follow-up history was not created.";
    }

    const formData = new FormData();
    formData.append("EventType", "insert");
    formData.append("JobHistoryId", null);
    formData.append("JobId", originJobId);
    formData.append("JobHistoryName", "");
    formData.append(
      "Description",
      this.formatFollowUpHistoryDescription(
        followupJobNum,
        followupJobDateTime,
        followupJobTime,
      ),
    );
    formData.append("Contact", "");
    formData.append("ContactEmail", "");
    formData.append("FileLocation", "");
    formData.append("FileName", "");
    formData.append("JobHistoryType", "Follow Up");
    formData.append("CreateDateTime", moment().format("YYYY-MM-DD HH:mm:ss"));
    formData.append("CreateByUserId", this.user.userid);
    formData.append("UpdateByUserId", null);
    formData.append("UpdateDateTime", null);
    formData.append("FormFile", formFile);

    return UploadFile("/savejobhistory", this.user.token, formData);
  }

  hasSameDayAppointments(entityType) {
    let entityIdName = "";
    let entityIdValue = "";
    if (entityType === "claimant") {
      entityIdName = "ClmId";
      entityIdValue = this.state.model.ClmId;
    } else {
      entityIdName = "IntId";
      entityIdValue = this.state.model.IntId;
    }

    if (!entityIdValue) {
      return Promise.resolve(false);
    }

    let sameDayApptModel = {
      [entityIdName]: entityIdValue,
      startDate: moment(this.state.model.JobDateTime).format("YYYY-MM-DD"),
    };

    let endPointName =
      entityType === "claimant"
        ? "/getsamedayappointmentscountclaimant"
        : "/getsamedayappointmentscountinterpreter";

    return FetchData(
      endPointName,
      "POST",
      this.user.token,
      sameDayApptModel,
    ).then((data) => data);
  }

  async onSave() {
    let model = { ...this.state.model };
    const originJobId = model.JobId;
    const followupJobDateTime = model.JobDateTime;
    const followupJobTime = model.JobTime;
    model.EventType = "insert";

    if (model.IntId === null || model.IntId === "") {
      if (
        window.confirm(
          "Are you sure you want to create a work order without an interpreter?",
        ) === false
      ) {
        return;
      }
    }

    if (model.JobDateTime == null || model.JobDateTime === "") {
      this.handleSaveEventSuccess({
        message: "Job Date and Time is required.",
        modal: true,
        color: "warning",
      });
    } else if (model.JobTime === null || model.JobTime === "") {
      this.handleSaveEventSuccess({
        message: "Job Date and Time is required.",
        modal: true,
        color: "warning",
      });
    } else {
      var strDay = moment(this.state.model.JobDateTime).format("dddd");

      if (strDay === "Saturday" || strDay === "Sunday") {
        if (
          window.confirm(
            "The appointment date is on " +
              strDay +
              ". Are you sure you want to save this record?",
          ) === true
        ) {
        } else return;
      } else {
        const modelEventType = model.EventType;
        const jobTypeText = this.state.model.JobTypeText || "";

        if (modelEventType === "insert" && jobTypeText !== "Conf Call") {
          let hasSameDayApptClm = false;
          let hasSameDayApptInt = false;

          if (this.state.model.ClmId) {
            hasSameDayApptClm = await this.hasSameDayAppointments("claimant");
          }

          const shouldCheckInterpreter =
            (this.state.model.IntLastName &&
              !this.state.model.IntLastName.startsWith("A ")) ||
            (!!this.state.model.IntId && !this.state.model.IntLastName);

          if (shouldCheckInterpreter) {
            hasSameDayApptInt =
              await this.hasSameDayAppointments("interpreter");
          }

          if (hasSameDayApptClm === true) {
            if (
              window.confirm(
                "Claimant already has a job on this day. Are you sure you want to save this record?",
              ) === true
            ) {
            } else return;

            if (hasSameDayApptInt === true) {
              if (
                window.confirm(
                  "Interpreter already has a job on this day. Are you sure you want to save this record?",
                ) === true
              ) {
              } else return;
            }
          }
        }
      }

      // model.JobNum = null;
      model.EventType = "insert";
      model.JobDateTime = moment(model.JobDateTime).format("YYYY-MM-DD");
      const now = moment();
      model.CallerNote =
        "Scheduled from Calendar " +
        now.format("MM/DD/YYYY") +
        " " +
        now.format("hh:mm A") +
        " By: " +
        this.user.firstname +
        " " +
        this.user.lastname;
      model.FinishTime = null;
      model.FinishTimeString = null;
      model.IntFee = null;
      model.IntFeeOther = null;
      model.IntOTFee = null;
      this.resetFollowUpFlags(model);
      model.ClmConfFlg = true;
      if (model.RemType === "d2f8a295-20e1-4653-b7c0-e456057cbd90") {
        model.RemClaimFlg = true;
        model.RemProvFlg = true;
        model.RemIntFlg = true;
      }
      model.CreateByUserId = this.user.userid;
      model.CreatedBy = this.user.firstname + " " + this.user.lastname;
      model.JobId = null;
      model.JobNum = null;
      model.intcheckdate = null;
      model.intchecknum = null;
      model.jobtotal = null;

      const data = await FetchData(
        "/saveworkorder",
        "POST",
        this.user.token,
        model,
      );

      if (data && data.message === "Success") {
        const followupHistoryResult = await this.saveFollowUpHistory(
          originJobId,
          data.jobNum,
          followupJobDateTime,
          followupJobTime,
          model.FormFile,
        );

        if (followupHistoryResult !== "Success") {
          this.handleSaveEventSuccess({
            message: followupHistoryResult,
            modal: true,
            color: "warning",
          });
          return;
        }

        this.props.handleSaveEventSuccess({
          message: data.message,
          modal: false,
          color: "success",
          model: { ...model, JobId: data.jobId, JobNum: data.jobNum },
        });
      } else {
        const message =
          (data && data.message) ||
          data ||
          "Unable to save follow-up workorder.";
        this.handleSaveEventSuccess({
          message: message,
          modal: true,
          color: "warning",
        });
      }
    }
  }

  render() {
    return (
      <div>
        <Modal
          isOpen={this.props.modal}
          toggle={this.props.setModal}
          style={{ height: "400px", width: "600px" }}
          backdrop="static"
        >
          <ModalHeader>New Followup</ModalHeader>
          <ModalBody style={{ height: "350px" }}>
            <Row>
              <Col style={{ textAlign: "center" }}>
                <Alert
                  color={this.state.alert.color}
                  isOpen={this.state.alert.isOpen}
                >
                  {this.state.alert.message}
                </Alert>
              </Col>
            </Row>
            <Row>
              <Col>
                <InputGroup size="sm">
                  <InputGroupText style={{ width: "74px" }}>
                    Date:
                  </InputGroupText>
                  <Input
                    name="JobDateTime"
                    type="date"
                    className="form-control-text"
                    value={this.state.model.JobDateTime}
                    onChange={this.handleChange}
                  />
                </InputGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <InputGroup size="sm">
                  <InputGroupText style={{ width: "74px" }}>
                    Time:
                  </InputGroupText>
                  <Input
                    name="JobTime"
                    type="text"
                    className="form-control-text"
                    value={this.state.model.JobTime}
                    onChange={this.handleChange}
                    onBlur={this.handleJobTimeFieldChange}
                  />
                </InputGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <InputGroup size="sm">
                  <InputGroupText style={{ width: "74px" }}>
                    Provider:
                  </InputGroupText>
                  <Input
                    type="text"
                    name="ProviderName"
                    className="form-control-text"
                    placeholder="Provider"
                    value={this.state.model.ProviderName}
                    onChange={this.handleChange}
                  />
                </InputGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <InputGroup size="sm">
                  <InputGroupText style={{ width: "74px" }}>
                    Appt Street:
                  </InputGroupText>
                  <Input
                    type="text"
                    name="AptStreet"
                    className="form-control-text"
                    placeholder="Appt Street"
                    value={this.state.model.AptStreet}
                    onChange={this.handleChange}
                  />
                </InputGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <InputGroup size="sm">
                  <InputGroupText style={{ width: "74px" }}>
                    Appt Name:
                  </InputGroupText>
                  <Input
                    name="AptName"
                    type="text"
                    className="form-control-text"
                    placeholder="Appt Name"
                    value={this.state.model.AptName}
                    onChange={this.handleChange}
                  />{" "}
                </InputGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <InputGroup size="sm">
                  <InputGroupText style={{ width: "74px" }}>
                    Appt Phone:
                  </InputGroupText>
                  <Input
                    name="AptPhone"
                    type="text"
                    className="form-control-text"
                    placeholder="Appt Phone"
                    value={this.state.model.AptPhone}
                    onChange={this.handleChange}
                  />{" "}
                </InputGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <InputGroup size="sm">
                  <InputGroupText style={{ width: "74px" }}>
                    Appt City:
                  </InputGroupText>
                  <Input
                    name="AptCity"
                    type="text"
                    className="form-control-text"
                    placeholder="Apt City"
                    value={this.state.model.AptCity}
                    onChange={this.handleChange}
                  />
                </InputGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <InputGroup size="sm">
                  <InputGroupText style={{ width: "74px" }}>
                    Appt State:
                  </InputGroupText>
                  <Input
                    name="AptState"
                    type="text"
                    className="form-control-text"
                    placeholder="Appt State"
                    value={this.state.model.AptState}
                    onChange={this.handleChange}
                  />
                </InputGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <InputGroup size="sm">
                  <InputGroupText style={{ width: "74px" }}>
                    Appt Zip:
                  </InputGroupText>
                  <Input
                    name="AptZip"
                    type="text"
                    className="form-control-text"
                    placeholder="Appt Zip"
                    value={this.state.model.AptZip}
                    onChange={this.handleChange}
                  />
                </InputGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <InputGroup size="sm">
                  <InputGroupText>Appt Details:</InputGroupText>
                  <Input
                    name="AptDirection"
                    type="text"
                    className="form-control-text"
                    placeholder="Appt Details"
                    value={this.state.model.AptDirection}
                    onChange={this.handleChange}
                  />
                </InputGroup>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.onSave}>
              Save
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}
